import axios from 'axios'
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    console.log(response)
    return response;
  }, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    if(error.response&&error.response.status==401){
        alert('身份已过期，请重新登录验证兑换查看')
        location.reload();
    }
    return Promise.reject(error);
  });